import React from 'react'
import { ListGroup } from 'react-bootstrap'
import './ATList.css'
import { useTranslation } from 'react-i18next'
import { convertDateToLocal } from '../../../utils/dateFormat/dateFormat'

interface ATListItemProps {
  listItem: any
  titleKey: string
  valueKey: string
  isActive: boolean
  handleSelectedItem: (val: any) => void
}

const ATListItem: React.FC<ATListItemProps> = ({
  listItem,
  titleKey,
  valueKey,
  isActive,
  handleSelectedItem,
}) => {
  const { t } = useTranslation(['translation'])
  return (
    <ListGroup.Item
      action
      active={isActive}
      onClick={() => handleSelectedItem(listItem?.[valueKey])}
    >
      <p className="list-item-title">{listItem?.[titleKey]}</p>
      <div className="list-item-created">
        <span className="list-item-created__label">
          {t('common.created_on')}
        </span>
        <span className="list-item-created__value">
          {convertDateToLocal(listItem?.createdDate)}
        </span>
      </div>
    </ListGroup.Item>
  )
}

export default ATListItem
